import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

export interface OptionType {
  label: string;
  value: string | number;
}

interface CustomDropdownProps {
  options: OptionType[];
  defaultValue?: OptionType;
  value?: OptionType;
  onChange?: (value: OptionType) => void;
  className?: string;
  placeholder?: string;
  modal?: boolean;
}

const CustomSelect: React.FC<CustomDropdownProps> = ({
  options,
  defaultValue,
  value,
  onChange,
  className,
  placeholder,
  modal,
}) => {
  const getPopupContainer = modal
    ? () =>
        (document.getElementsByClassName('modal')[0] as HTMLElement) ||
        document.body
    : undefined;

  return (
    <Select
      defaultValue={defaultValue}
      value={value}
      onChange={(val: any) => {
        if (onChange) onChange(val);
      }}
      className={className}
      placeholder={placeholder}
      style={{ width: '100%' }}
      getPopupContainer={getPopupContainer}
      labelInValue
    >
      {options.map((option) => (
        <Option key={option.value} value={option.value}>
          {option.label}
        </Option>
      ))}
    </Select>
  );
};

export default CustomSelect;

